module.exports = __webpack_public_path__ + "static/media/Saint Lucia.f4da6c29.png";